<span class="mx-button-tooltip-container inline-flex" [matTooltip]="computedTooltip" (click)="onClick($event)">
  @if (genericRouteName) {
    <a mat-button [mxNamedRouterLink]="genericRouteName" [mxNamedRouterLinkParams]="routeParams" [mxQueryParams]="queryParams"
       [mxNamedRouterLinkEnabled]="enabled" [color]="color" [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex"
       class="mx-button-component">
      <ng-container [ngTemplateOutlet]="buttonContent.content" [ngTemplateOutletContext]="buttonContentContext"/>
    </a>
  } @else if (href) {
    <a mat-button [attr.href]="computedHref" [attr.target]="externalLinkTarget" [attr.rel]="externalLinkRelationship" [color]="color"
       [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex" class="mx-button-component">
      <ng-container [ngTemplateOutlet]="buttonContent.content" [ngTemplateOutletContext]="buttonContentContext"/>
    </a>
  } @else {
    <button mat-button [type]="type" [color]="color" [disabled]="!enabled" class="mx-button-component">
      <ng-container [ngTemplateOutlet]="buttonContent.content" [ngTemplateOutletContext]="buttonContentContext"/>
    </button>
  }
</span>

<mx-rectangular-button-content #buttonContent/>
